export default function(router) {
  router.beforeEach((to, from, next) => {
    localStorage.setItem('fromPath', from.fullPath)
    let host = window.location.hostname
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    let hostList = ['www.daoba.com', 'daoba.com', 'localhost', '192.168.2.130', 'cqgxq.matchn.cn', 'cqjlp.matchn.cn']
    let hostName = '道吧网'
    if (host == 'cqgxq.matchn.cn') {
      hostName = '重庆高新区智慧体育平台'
    } else if (host == 'cqjlp.matchn.cn') {
      hostName = '重庆九龙坡智慧体育平台'
    } else if (host == 'cqjlp.matchn.cn') {
      hostName = '重庆市九龙坡区第十二届区运会'
    }
    if (hostList.indexOf(host) > -1) {
      if (to.meta.title) {
        document.title = `${to.meta.title} |  ` + hostName
      } else {
        document.title = hostName
      }
    } else {
      document.title = to.meta.title
    }

    // safari
    window.pageYOffset = 0
    next()
  })
}



// WEBPACK FOOTER //
// ./src/comm/router/config.js